module.exports = __webpack_public_path__ + "content/831f521a1b75457a4f28e830de33d48e.png";